export const queryKeys = {
  vendor: {
    settings: () => ['vendor', 'settings'],
  },
  notifications: {
    unreadCount: () => ['notifications', 'unread-count'],
    list: (perPage = 10, page = 1) => ['notifications', 'list', perPage, page],
  },
};
